<template>
    <DsDropdown
        disable-scroll
        :is-open="isOpen"
        position="bottom-end"
    >
        <template #default>
            <DsIconButton
                name="more-vertical"
                @click="toggleMenu"
            />
        </template>
        <template #menu>
            <ul class="dropdown-menu-list">
                <li
                    v-if="isMainMenu"
                    class="dropdown-menu-item no-hover"
                >
                    <DsToggleSwitch
                        :value="cellIsReady"
                        :label-on="$t('funnel.header.readyToggle.ready')"
                        :label-off="$t('funnel.header.readyToggle.draft')"
                        class="fulfillment-ready-toggle"
                        @input="toggleCellReady"
                    />
                </li>
                <template v-if="isMainMenu">
                    <li
                        v-for="option in $options.FULFILLMENT_MENU_ITEMS"
                        :key="option.ID"
                        class="dropdown-menu-item"
                        @click="handleSelection(option.ID)"
                    >
                        <div class="menu-item">
                            <DsIcon
                                class="menu-icon"
                                :name="option.ICON"
                            />
                            <span class="menu-label">
                                {{ $t(option.LABEL) }}
                            </span>
                            <DsIcon
                                v-if="option.SUBMENU"
                                class="sub-menu"
                                name="chevron-right"
                            />
                        </div>
                    </li>
                </template>
                <template v-else-if="isTest">
                    <li
                        class="dropdown-menu-item bottom-line"
                        @click="goBackInMenu"
                    >
                        <div class="menu-item">
                            <DsIcon
                                class="menu-icon"
                                name="arrow-left"
                            />
                            <span class="menu-label">
                                {{ $t($options.FULFILLMENT_MENU_ITEMS.TEST.LABEL) }}
                            </span>
                        </div>
                    </li>
                    <li
                        v-for="user in users"
                        :key="user.value"
                        class="dropdown-menu-item"
                        @click="handleTest(user.value)"
                    >
                        <div class="menu-item">
                            <DsIcon
                                class="menu-icon"
                                :name="$options.FULFILLMENT_MENU_ITEMS.TEST.SUB_ICON"
                            />
                            <span class="menu-label">
                                {{ user.label }}
                            </span>
                        </div>
                    </li>
                </template>
                <template v-else-if="isCopy">
                    <li
                        class="dropdown-menu-item bottom-line"
                        @click="goBackInMenu"
                    >
                        <div class="menu-item">
                            <DsIcon
                                class="menu-icon"
                                name="arrow-left"
                            />
                            <span class="menu-label">
                                {{ $t($options.FULFILLMENT_MENU_ITEMS.COPY.LABEL) }}
                            </span>
                        </div>
                    </li>
                    <li
                        v-if="!optionsLoaded"
                        class="loading-spinner"
                    >
                        <DsSpinner
                            :size="100"
                        />
                    </li>
                    <li
                        v-for="(option, index) in copyOptions"
                        v-else
                        :key="index"
                        class="dropdown-menu-item"
                        @click="handleCopy(option.value)"
                    >
                        <div class="submenu-item">
                            <DsIcon
                                class="submenu-icon"
                                :name="$options.FULFILLMENT_MENU_ITEMS.COPY.SUB_ICON"
                            />
                            <span class="submenu-label">
                                {{ $t(option.label) }}
                            </span>
                            <span class="submenu-subtext">
                                {{ $t(option.subtext) }}
                            </span>
                        </div>
                    </li>
                </template>
            </ul>
        </template>
    </DsDropdown>
</template>

<script>
import { FULFILLMENT_MENU_ITEMS } from '../../../../utils/editor.constants';

export default {
    FULFILLMENT_MENU_ITEMS,

    props: {
        cellIsReady: {
            type: Boolean,
            required: true,
        },
        optionsLoaded: {
            type: Boolean,
            required: true,
        },
        users: {
            type: Array,
            required: true,
        },
        copyOptions: {
            type: Array,
            required: true,
        },
    },
    emits: ['toggle-cell-ready', 'menu-item-clicked', 'load-copy-options'],

    data() {
        return {
            isOpen: false,
            isMainMenu: true,
            isTest: false,
            isCopy: false,
        };
    },

    methods: {
        toggleMenu() {
            this.isOpen = !this.isOpen;
            this.goBackInMenu();
        },

        close() {
            this.isOpen = false;
            this.goBackInMenu();
        },

        toggleCellReady() {
            this.$emit('toggle-cell-ready');
        },

        handleSelection(optionId) {
            switch (optionId) {
            case FULFILLMENT_MENU_ITEMS.TEST.ID:
                this.showTest();
                break;
            case FULFILLMENT_MENU_ITEMS.COPY.ID:
                this.showCopy();
                break;
            default:
                break;
            }
        },

        showTest() {
            this.isMainMenu = false;
            this.isTest = true;
        },

        showCopy() {
            this.$emit('load-copy-options');
            this.isMainMenu = false;
            this.isCopy = true;
        },

        goBackInMenu() {
            this.isMainMenu = true;
            this.isTest = false;
            this.isCopy = false;
        },

        handleTest(userId) {
            this.$emit('menu-item-clicked', {
                optionId: FULFILLMENT_MENU_ITEMS.TEST.ID,
                data: Number(userId),
            });
            this.close();
        },

        handleCopy(fulfillmentId) {
            this.$emit('menu-item-clicked', {
                optionId: FULFILLMENT_MENU_ITEMS.COPY.ID,
                data: Number(fulfillmentId),
            });
            this.close();
        },
    },
};
</script>
<style lang="scss" scoped>
ul.dropdown-menu-list {
    width: px-to-rem(295);
    padding: 0;
    overflow: hidden;

    li {
        padding: px-to-rem(12) $line-height-xs !important;

        div.menu-item {
            display: grid;
            grid-template-areas: 'menuicon menulabel submenu';
            grid-template-columns: px-to-rem(48) px-to-rem(175) auto;
            align-items: center;
            justify-items: left;

            span {
                background: none;
                font-size: $font-size-md;
                font-weight: 400;
                line-height: $line-height-lg;
            }
        }
    }

    li.no-hover:hover {
        background-color: $color-paper;
    }

    li.bottom-line {
        border-bottom: 1px solid $color-gray-100;
    }

    .loading-spinner {
        display: flex;
        justify-content: center;
    }

    .menu-icon {
        grid-area: menuicon;
        margin-left: $spacing-100;
    }

    .menu-label {
        grid-area: menulabel;
    }

    .sub-menu {
        grid-area: submenu;
    }

    .submenu-item {
        display: grid;
        grid-template-areas: 'submenuicon submenulabel' 'submenuicon submenusubtext';
        grid-template-rows: px-to-rem(24) px-to-rem(12);
        grid-template-columns: px-to-rem(48) auto;
        align-items: center;
        justify-items: left;

        span {
            background: none;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .submenu-icon {
        grid-area: submenuicon;
        margin-left: $spacing-100;
    }

    .submenu-label {
        grid-area: submenulabel;
        font-size: $font-size-md;
        font-weight: 400;
        line-height: $line-height-lg;
    }

    .submenu-subtext {
        grid-area: submenusubtext;
        font-size: $font-size-xs;
        font-weight: 400;
        line-height: $line-height-xs;
        color: $color-ink-800;
    }
}

.fulfillment-ready-toggle {
    font-weight: normal;
    font-size: $font-size-md;
}
</style>
<style lang="scss">
.fulfillment-ready-toggle {
    span {
        background: none;
    }
}
</style>
